module.exports = __webpack_public_path__ + "img/Rectangle3015.6dfa4a0f.png";